import { Pipe, PipeTransform } from "@angular/core";
import { Aroma } from "../models/aroma";
import { Drink } from "../models/drink";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "translationSort",
  pure: true,
})
export class TranslationSortPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(thingsToSort: Aroma[] | Drink[], type: string): any {
    if (!thingsToSort) {
      return false;
    }
    const result = thingsToSort.sort((a, b) => {
      if (b.id === 0) {
        console.log(a.identifier);
        return 1;
      }
      const nameA = this.translate
        .instant(`${type}.` + a.identifier)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const nameB = this.translate
        .instant(`${type}.` + b.identifier)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      } else {
        return 0;
      }
    });
    return result;
  }
}
